import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Sidebar from '../Sidebar';

const Layout = ({ children, showFooter = true, withSidebar = false }) => {
  return (
    <div className="min-h-screen bg-black flex flex-col" style={{ overflowX: 'clip' }}>
      <Header />
      <main className="flex-1">
        {withSidebar ? (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="grid grid-cols-1 lg:grid-cols-[350px_1fr] gap-8">
              {/* Desktop sidebar - sticky on left */}
              <div className="hidden lg:block">
                <div className="sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto scrollbar-thin">
                  <Sidebar />
                </div>
              </div>
              <div className="min-w-0">
                {children}
              </div>
              {/* Mobile sidebar - below content */}
              <div className="lg:hidden">
                <Sidebar />
              </div>
            </div>
          </div>
        ) : (
          children
        )}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
